import type { ProductFormulation } from '@/constants/products';
import { UNIT_BY_FORMULATION } from './constants';

/** The unit a formulation is measured in, e.g. 'g'; undefined when it has none or no formulation is chosen */
export const getFormulationUnit = (formulation: ProductFormulation | undefined) =>
  formulation ? UNIT_BY_FORMULATION.get(formulation) : undefined;
